export class IsiPagineState {

    id: string;
    expandedRows: any[];

    /// <summary>
    ///  Classe correspondant a une page de pagination. Contient les informations a sauvegarder par page.
    /// </summary>
    /// <param name="id" type="string">L'Index de la page.</param>
    constructor(id) {
        this.id = id;
        this.expandedRows = [];
    }

    setExpandedRows(rows: any[]) {
        /// <summary>
        ///  Affecte une collection de lignes etendues.
        /// </summary>
        /// <param name="rows" type="Array">Collection de lignes etendues.</param>
        this.expandedRows = rows;
    }
    dispose() {
        this.expandedRows = null;
    }
}
